import React from 'react';
import { motion } from 'framer-motion';
import { MoveHorizontalIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { programNumbers } from '../data/content';
export function ProgramNumbers() {
  return <section className="w-full bg-cream py-16 sm:py-24" aria-labelledby="numeros" data-id="element-101" data-mp="b4a55mlgz51g">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-102" data-mp="74hrwwl4sapr">
        <div className="flex flex-col items-center" data-id="element-103" data-mp="3fj07djdeisje">
          <SectionHeading eyebrow="Números" title="El programa en números" subtitle="Diseñado para que veas resultados reales" intro="Simple, progresivo y completamente adaptado a tu cuerpo y tu ritmo." data-id="element-104" data-mp="3fjjnqvnel8vb" />
        </div>

        <p className="mt-10 flex items-center justify-center gap-2 text-sm text-muted md:hidden" data-id="element-105" data-mp="3jjk1sf6lbi1u">
          <MoveHorizontalIcon className="h-4 w-4" aria-hidden="true" data-id="element-106" data-mp="13sfpi88m2s0r" />
          Deslizá para ver la tabla completa
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mt-4 overflow-x-auto rounded-4xl border border-linen bg-sand/70 md:mt-12" data-id="element-107" data-mp="yturmfgu0kfh">
          <table className="w-full min-w-[32rem] border-collapse text-left" data-id="element-108" data-mp="2xyo3u5yry6fv">
            <caption className="sr-only" data-id="element-109" data-mp="32z2431u4wc3c">
              El programa en números: qué significa cada dato
            </caption>
            <thead data-id="element-110" data-mp="259yzzz6c3n0f">
              <tr className="border-b border-linen" data-id="element-111" data-mp="2aamxn3p2j23m">
                <th scope="col" className="px-6 py-5 text-sm font-bold uppercase tracking-[0.16em] text-clay sm:px-8" data-id="element-112" data-mp="2ab68k0gawq85">
                  Número
                </th>
                <th scope="col" className="px-6 py-5 text-sm font-bold uppercase tracking-[0.16em] text-clay sm:px-8" data-id="element-113" data-mp="2k2j0es23nge6">
                  Qué significa
                </th>
              </tr>
            </thead>
            <tbody data-id="element-114" data-mp="1jief50lo7kc1">
              {programNumbers.map(item => <tr key={item.value} className="border-b border-linen last:border-0" data-id="element-115" data-mp="1fink2kp42i1p">
                  <th scope="row" className="whitespace-nowrap px-6 py-6 font-display text-4xl font-semibold text-sage-dark sm:px-8 sm:text-5xl" data-id="element-116" data-mp="1t994idu7r01p">
                    {item.value}
                  </th>
                  <td className="px-6 py-6 text-lg leading-relaxed text-ink sm:px-8" data-id="element-117" data-mp="10l4ujg4m00t7">
                    {item.meaning}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>;
}